<script setup lang="ts">
import type { DtoClass } from '@/objects/generated';
import { useAccessStoreRef } from '@/stores';

const { HiddenFields } = useAccessStoreRef();
defineProps<{
    className: DtoClass;
    field: string;
}>();
</script>
<template>
    <template v-if="!(HiddenFields.has(className) && HiddenFields.get(className)!.includes(field))">
        <slot></slot>
    </template>
</template>
